import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-705f1d88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "options fixed-top" }
const _hoisted_2 = { class: "list-unstyled components" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, " Select Site ")
  ])
], -1))
const _hoisted_4 = { class: "sidebar-indicators" }
const _hoisted_5 = { class: "cell" }
const _hoisted_6 = { class: "cell" }
const _hoisted_7 = { class: "name" }

import { storeToRefs } from 'pinia';
    import { useSSE, useAuth, useRoot } from '@/stores/store';
    import { SelectedSite } from '@/types/root-types';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

    const sseState = useSSE();
    const rootState = useRoot();
    const authState = useAuth();

    const { user } = storeToRefs(authState);
    const { getConnectionStatus } = storeToRefs(sseState);
    const { getSidebarStatus, getSelectedSite } = storeToRefs(rootState);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    id: "sidebar",
    style: _normalizeStyle([_unref(getSidebarStatus) ? 'width: 250px' : 'width: 50px'])
  }, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(rootState).selectedSite = _unref(SelectedSite).AnnArbor), ["prevent"])),
                  class: _normalizeClass([_unref(getSelectedSite) == _unref(SelectedSite).AnnArbor ? 'selected-site' : undefined])
                }, "Ann Arbor", 2)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(rootState).selectedSite = _unref(SelectedSite).Dearborn), ["prevent"])),
                  class: _normalizeClass([_unref(getSelectedSite) == _unref(SelectedSite).Dearborn ? 'selected-site' : undefined])
                }, "Dearborn", 2)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(rootState).selectedSite = _unref(SelectedSite).Flint), ["prevent"])),
                  class: _normalizeClass([_unref(getSelectedSite) == _unref(SelectedSite).Flint ? 'selected-site' : undefined])
                }, "Flint", 2)
              ])
            ])
          ])
        ], 512), [
          [_vShow, _unref(getSidebarStatus)]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          class: _normalizeClass(["indicator", [
                    _unref(getConnectionStatus) ? 'connected': 'disconnected',
                ]])
        }, null, 2)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(user).name), 1)
      ], 512), [
        [_vShow, _unref(getSidebarStatus)]
      ])
    ])
  ], 4))
}
}

})